/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Proof_ReadersInputs */

const en_funnel_ob_proof_readers = /** @type {(inputs: Funnel_Ob_Proof_ReadersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`readers`)
};

const es_funnel_ob_proof_readers = /** @type {(inputs: Funnel_Ob_Proof_ReadersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lectores`)
};

/**
* | output |
* | --- |
* | "readers" |
*
* @param {Funnel_Ob_Proof_ReadersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_proof_readers = /** @type {((inputs?: Funnel_Ob_Proof_ReadersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Proof_ReadersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_proof_readers(inputs)
	return en_funnel_ob_proof_readers(inputs)
});